import { render, staticRenderFns } from "./realInventory.vue?vue&type=template&id=a72ffff0&scoped=true"
import script from "./realInventory.vue?vue&type=script&lang=js"
export * from "./realInventory.vue?vue&type=script&lang=js"
import style0 from "./realInventory.vue?vue&type=style&index=0&id=a72ffff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ffff0",
  null
  
)

export default component.exports